import { render, staticRenderFns } from "./MessagePancake.vue?vue&type=template&id=5177c26a"
import script from "./MessagePancake.vue?vue&type=script&lang=js"
export * from "./MessagePancake.vue?vue&type=script&lang=js"
import style0 from "./MessagePancake.vue?vue&type=style&index=0&id=5177c26a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports